module.exports = __webpack_public_path__ + "static/media/zeya_shakes_head.105c3829.gif";